import { expVal } from '@atlassian/jira-feature-experiments';

const CustomTemplatesV1GatesFeCleanupRelayProvider = {
	get(): boolean {
		return expVal('custom_templates_v1_gates_fe_cleanup', 'isEnabled', false);
	},
};

export default CustomTemplatesV1GatesFeCleanupRelayProvider;
